import React, { useEffect, useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Apiurl from "../../environment/Apiurl";

const Update_JobSheet = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showAddService, setShowAddService] = useState(false);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [serviceSearch, setServiceSearch] = useState("");
  const [brands, setBrands] = useState([]);
  const [staff, setStaff] = useState([]);
  const [models, setModels] = useState([]);
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [billStaff, setBillStaff] = useState("");
  const [jobSheetNo, setJobSheetNo] = useState("");

  const [showAddModelModal, setShowAddModelModal] = useState(false);

  const [newModelData, setNewModelData] = useState({
    modelName: "",
    brand: "",
    modelStatus: "Active",
  });

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    time: getCurrentTime(),
    sheet_no: "",
    customer_name: "",
    mobile_number: "",
    customer_address: "",
    mobile_brand: "",
    mobile_model: "",
    mobile_imei: "",
    customer_care_officer: "",
    warranty_status: "",
    apperance_status: "",
  });

  const [selectedService, setSelectedService] = useState({
    complaint_name: "",
    complaint_no: "",
    complaint_notes: "",
  });

  const [isManual, setIsManual] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isAddingService, setIsAddingService] = useState(false);

  // Fetch Staff & Username
  useEffect(() => {
    const getStaff = localStorage.getItem("username");
    if (getStaff) {
      setBillStaff(getStaff);
      setFormData((prev) => ({ ...prev, customer_care_officer: getStaff }));
    }
  }, []);

  useEffect(() => {
    const fetchJobSheet = async () => {
      try {
        const response = await axios.get(`${Apiurl}/job-sheet/${id}`);

        const data = response.data;

        setFormData({
          date: data.date
            ? new Date(data.date).toISOString().split("T")[0]
            : "",
          time: convertTo24Hour(data.time || ""),
          sheet_no: data.sheet_no || "",
          customer_name: data.customer_name || "",
          mobile_number: data.mobile_number || "",
          customer_address: data.customer_address || "",
          mobile_brand: data.mobile_brand || "",
          mobile_model: data.mobile_model || "",
          mobile_imei: data.mobile_imei || "",
          customer_care_officer: data.customer_care_officer || "",
          warranty_status: data.warranty_status || "",
          apperance_status: data.apperance_status || "",
        });

        setSelectedServices(
          (data.complaint_details || []).map((item) => ({
            service_name: item.complaint_name,
            complaint_no: item.complaint_no,
            complaint_notes: item.complaint_notes,
          })),
        );
      } catch (error) {
        console.log(error);
      }
    };

    fetchJobSheet();
  }, [id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(`${Apiurl}/staff`);

        const filteredStaff = response.data.filter(
          (data) => data.role === "Customer Care Officer",
        );

        setStaff(filteredStaff);
      } catch (error) {
        console.error("Error fetching staff:", error);
      }
    };

    fetchStaff();
  }, []);

  // Fetch Job Sheet Number
  useEffect(() => {
    const fetchJobSheetNo = async () => {
      try {
        const response = await axios.get(`${Apiurl}/generate_jobsheetno`);
        const jobsheetno = response.data.sheet_no || response.data.bill_no;
        setJobSheetNo(jobsheetno);
        setFormData((prev) => ({ ...prev, sheet_no: jobsheetno }));
      } catch (error) {
        console.error("Error fetching job sheet number:", error);
      }
    };
    fetchJobSheetNo();
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${Apiurl}/brand`);
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    const fetchServices = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${Apiurl}/service`);
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBrands();
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchModels = async () => {
      if (formData.mobile_brand) {
        try {
          const response = await axios.get(
            `${Apiurl}/model?brand_name=${encodeURIComponent(formData.mobile_brand)}`,
          );
          setModels(
            response.data.filter((m) => m.brand_name === formData.mobile_brand),
          );
        } catch (error) {
          console.error("Error fetching models:", error);
          setModels([]);
        }
      } else {
        setModels([]);
      }
    };
    fetchModels();
  }, [formData.mobile_brand]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "mobile_brand") {
      setFormData((prev) => ({
        ...prev,
        mobile_brand: value,
        mobile_model: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleServiceSearchChange = (e) => {
    setServiceSearch(e.target.value);
    setShowServiceDropdown(true);
  };

  const filteredServices = services.filter((service) =>
    `${service.serviceName} ${service.category} ${service.serviceType} ${service.description}`
      .toLowerCase()
      .includes(serviceSearch.toLowerCase()),
  );

  const selectService = (service) => {
    const newService = {
      service_id: service._id,
      service_name: service.serviceName,
      complaint_no: service.complaintCode,
      complaint_notes: "",
    };

    setSelectedServices((prev) => [...prev, newService]);

    setServiceSearch("");
    setShowServiceDropdown(false);
  };

  const handleServiceInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedService((prev) => ({ ...prev, [name]: value }));
  };

  const addServiceToTable = () => {
    if (isAddingService) return;
    setIsAddingService(true);

    let tempService = { ...selectedService };
    if (!tempService.service_name) tempService.service_name = serviceSearch;

    if (!tempService.service_name) {
      alert("Please enter a service name");
      setIsAddingService(false);
      return;
    }

    setSelectedServices((prev) => {
      if (editIndex !== null) {
        const updated = [...prev];
        updated[editIndex] = tempService;
        return updated;
      } else {
        return [...prev, tempService];
      }
    });

    setSelectedService({
      complaint_name: "",
      complaint_no: "",
      complaint_notes: "",
    });
    setServiceSearch("");
    setIsManual(false);
    setEditIndex(null);
    setIsAddingService(false);
    setShowAddService(false);
  };

  const editService = (index) => {
    setSelectedService(selectedServices[index]);
    setServiceSearch(selectedServices[index].service_name);
    setEditIndex(index);
    setShowAddService(true);
  };

  // const removeService = (index) => {
  //   setSelectedServices((prev) => prev.filter((_, i) => i !== index));
  //   if (editIndex === index) setEditIndex(null);
  // };

  const removeService = (index) => {
    if (selectedServices.length === 1) {
      setSelectedServices([
        {
          service_name: "",
          complaint_no: "",
          complaint_notes: "",
        },
      ]);
      return;
    }

    setSelectedServices((prev) => prev.filter((_, i) => i !== index));
  };

  // Add new model
  const handleNewModelInputChange = (e) => {
    const { name, value } = e.target;

    setNewModelData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModel = async (e) => {
    e.preventDefault();

    if (!newModelData.modelName.trim()) {
      alert("Model Name is required");
      return;
    }

    if (!newModelData.brand) {
      alert("Brand is required");
      return;
    }

    try {
      const modelData = {
        model_name: newModelData.modelName.trim(),
        brand_name: newModelData.brand,
        status: newModelData.modelStatus,
      };

      await axios.post(`${Apiurl}/model`, modelData);

      const response = await axios.get(
        `${Apiurl}/model?brand_name=${encodeURIComponent(newModelData.brand)}`,
      );

      const updatedModels = response.data.filter(
        (m) => m.brand_name === newModelData.brand,
      );

      setModels(updatedModels);

      setFormData((prev) => ({
        ...prev,
        mobile_model: newModelData.modelName.trim(),
      }));

      setShowAddModelModal(false);

      setNewModelData({
        modelName: "",
        brand: formData.mobile_brand,
        modelStatus: "Active",
      });
    } catch (error) {
      console.error("Error adding model:", error);

      alert(error?.response?.data?.message || "Failed to add model");
    }
  };

  const handleCloseAddModelModal = () => {
    setShowAddModelModal(false);

    setNewModelData({
      modelName: "",
      brand: formData.mobile_brand,
      modelStatus: "Active",
    });
  };

  //   const convertTo12Hour = (time24) => {
  //     if (!time24) return "";

  //     let [hours, minutes] = time24.split(":");
  //     hours = parseInt(hours, 10);

  //     const ampm = hours >= 12 ? "PM" : "AM";
  //     hours = hours % 12 || 12;

  //     return `${hours}:${minutes} ${ampm}`;
  //   };

  const convertTo24Hour = (time12h) => {
    if (!time12h) return "";

    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${String(hours).padStart(2, "0")}:${minutes}`;
  };

  const handleUpdate = async () => {
    if (!formData.customer_name || selectedServices.length === 0) {
      alert("Please enter customer name and add at least one complaint.");
      return;
    }

    try {
      const updateData = {
        sheet_no: formData.sheet_no,
        customer_name: formData.customer_name,
        mobile_number: formData.mobile_number,
        customer_address: formData.customer_address,
        mobile_brand: formData.mobile_brand,
        mobile_model: formData.mobile_model,
        mobile_imei: formData.mobile_imei,
        customer_care_officer: formData.customer_care_officer || billStaff,
        warranty_status: formData.warranty_status,
        apperance_status: formData.apperance_status,
        date: formData.date,
        time: convertTo24Hour(formData.time),

        complaint_details: selectedServices.map((item) => ({
          complaint_name: item.service_name,
          complaint_no: item.complaint_no,
          complaint_notes: item.complaint_notes || "",
        })),
      };

      const res = await axios.put(`${Apiurl}/job-sheet/${id}`, updateData);

      if (res.status === 200 || res.status === 201) {
        const updatedId = res.data._id;
        navigate(`/job-sheet/invoice-job-sheet-bill/${updatedId}`);
      }
    } catch (error) {
      console.log(error);
      alert("Failed to update Job Sheet");
    }
  };

  const handleClearOverAll = () => {
    setFormData({
      customer_name: "",
      mobile_number: "",
      customer_address: "",
      mobile_brand: "",
      mobile_model: "",
      mobile_imei: "",
      customer_care_officer: "",
      warranty_status: "",
      apperance_status: "",
    });

    setSelectedService({
      complaint_name: "",
      complaint_no: "",
      complaint_notes: "",
    });
  };

  const handleCancel = () => {
    navigate("/job-sheet");
  };

  return (
    <>
      <style>
        {`
          .form-control, .form-select {
            border: 1px solid #00000086 !important;
          }
          .input-group .form-control {
            border-right: none !important;
          }
          .input-group .btn {
            border: 1px solid #00000086 !important;
          }
          .table-scroll-350 {
            max-height: 350px;
            overflow-y: auto;
          }
        `}
      </style>

      <div className="p-3" style={{ overflow: "hidden" }}>
        {error && <div className="alert alert-danger">{error}</div>}
        {isLoading && <div className="alert alert-info">Loading...</div>}

        <div className="row">
          {/* Left Side */}
          <div className="col-lg-9 col-xl-9">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-12">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="mb-1 fw-bold">Customer Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="customer_name"
                        value={formData.customer_name}
                        onChange={handleInputChange}
                        placeholder="Enter Customer Name"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="mb-1 fw-bold">Mobile No</label>
                      <input
                        className="form-control"
                        type="text"
                        name="mobile_number"
                        value={formData.mobile_number}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          setFormData({
                            ...formData,
                            mobile_number: value,
                          });
                        }}
                        maxLength={10}
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="mb-1 fw-bold">Address</label>
                      <input
                        className="form-control"
                        name="customer_address"
                        value={formData.customer_address}
                        onChange={handleInputChange}
                        placeholder="Enter Address"
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">Brand</label>
                      <select
                        className="form-select"
                        name="mobile_brand"
                        value={formData.mobile_brand}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Brand --</option>
                        {brands.map((brand) => (
                          <option key={brand._id} value={brand.brand_name}>
                            {brand.brand_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="col-md-3">
                      <label className="mb-1 fw-bold">Model</label>
                      <select
                        className="form-select"
                        name="mobile_model"
                        value={formData.mobile_model}
                        onChange={handleInputChange}
                        disabled={!formData.mobile_brand}
                      >
                        <option value="">-- Select Model --</option>
                        {models.map((model) => (
                          <option key={model._id} value={model.model_name}>
                            {model.model_name}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">Model</label>

                      <div className="input-group">
                        <select
                          className="form-select"
                          name="mobile_model"
                          value={formData.mobile_model}
                          onChange={handleInputChange}
                          disabled={!formData.mobile_brand}
                        >
                          <option value="">-- Select Model --</option>

                          {models.map((model) => (
                            <option key={model._id} value={model.model_name}>
                              {model.model_name}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={!formData.mobile_brand}
                          onClick={() => {
                            setNewModelData({
                              modelName: "",
                              brand: formData.mobile_brand,
                              modelStatus: "Active",
                            });

                            setShowAddModelModal(true);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">IMEI</label>
                      <input
                        className="form-control"
                        type="text"
                        name="mobile_imei"
                        value={formData.mobile_imei}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");

                          if (value.length <= 15) {
                            setFormData({
                              ...formData,
                              mobile_imei: value,
                            });
                          }
                        }}
                        placeholder="Enter IMEI"
                        maxLength={15}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">
                        Customer Care Officer
                      </label>
                      <select
                        className="form-select"
                        name="customer_care_officer"
                        value={formData.customer_care_officer}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Officer --</option>
                        {staff.map((person) => (
                          <option key={person._id} value={person.full_name}>
                            {person.full_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Section - Same Design */}
            <div className="row p-2">
              <div className="border rounded p-3 bg-white">
                <div className="d-flex justify-content-between align-items-center my-2">
                  <div>
                    <span className="fw-bold">Service Table</span>
                  </div>
                  <div>
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() =>
                        setSelectedServices([
                          ...selectedServices,
                          {
                            service_name: "",
                            complaint_no: "",
                            complaint_notes: "",
                          },
                        ])
                      }
                    >
                      + Add Complaint
                    </button>
                  </div>
                </div>

                <table className="table table-hover">
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{
                          background: "#2e9290",
                          color: "#fff",
                          width: "60px",
                        }}
                      >
                        S.No
                      </th>

                      <th style={{ background: "#2e9290", color: "#fff" }}>
                        Complaint
                      </th>

                      <th
                        style={{
                          background: "#2e9290",
                          color: "#fff",
                          width: "90px",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedServices.length > 0 ? (
                      selectedServices.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center align-middle">
                            {index + 1}
                          </td>

                          <td>
                            <input
                              type="text"
                              className="form-control mb-2 fw-bold"
                              placeholder="Enter Complaint"
                              value={item.service_name}
                              onChange={(e) => {
                                const updated = [...selectedServices];
                                updated[index].service_name = e.target.value;
                                setSelectedServices(updated);
                              }}
                            />

                            <textarea
                              className="form-control"
                              rows={2}
                              placeholder="Complaint Notes"
                              value={item.complaint_notes}
                              onChange={(e) => {
                                const updated = [...selectedServices];
                                updated[index].complaint_notes = e.target.value;
                                setSelectedServices(updated);
                              }}
                            />
                          </td>

                          <td className="text-center align-middle">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => removeService(index)}
                            >
                              <Trash2 size={16} />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No services selected
                        </td>
                      </tr>
                    )}
                  </tbody>

                  {selectedServices.length > 0 && (
                    <tfoot>
                      <tr>
                        <td colSpan={3}>
                          <div>
                            <label className="form-label fw-semibold mb-1">
                              Apperance Status :
                            </label>

                            <textarea
                              className="form-control"
                              rows={2}
                              name="apperance_status"
                              placeholder="Enter Apperance Status"
                              value={formData.apperance_status}
                              onChange={handleInputChange}
                            />
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  )}

                  {/* <tfoot>
                                <tr>
                                  <td colSpan={3}>
                                    <button
                                      className="btn btn-success"
                                      onClick={() =>
                                        setSelectedServices([
                                          ...selectedServices,
                                          {
                                            service_name: "",
                                            complaint_no: "",
                                            complaint_notes: "",
                                          },
                                        ])
                                      }
                                    >
                                      + Add Complaint
                                    </button>
                                  </td>
                                </tr>
                              </tfoot> */}
                </table>
              </div>
            </div>
          </div>

          {/* Right Side - Simplified */}
          <div className="col-lg-3 col-xl-3">
            <div className="card">
              <div className="card-body py-1 px-3">
                <div className="row g-3">
                  <div className="col-6">
                    <label className="mb-1 fw-bold">Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="date"
                      value={formData.date}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-6">
                    <label className="mb-1 fw-bold">Time</label>
                    <input
                      className="form-control form-control-sm"
                      type="time"
                      name="time"
                      value={formData.time}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1 fw-bold">Job Sheet No</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      value={formData.sheet_no}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-3">
              <div className="card-body p-4">
                <div className="row g-3 align-items-end">
                  {/* Warranty Status */}
                  <div className="col-md-12">
                    <label className="form-label fw-bold">
                      Warranty Status
                    </label>

                    <select
                      name="warranty_status"
                      className="form-select"
                      value={formData.warranty_status}
                      onChange={handleInputChange}
                    >
                      <option value="">-- Select Warranty --</option>
                      <option value="Out of warranty">Out Of Warranty</option>
                      <option value="In warranty">In Warranty</option>
                    </select>
                  </div>

                  {/* Buttons */}
                  <div className="col-md-4">
                    <button
                      className="btn btn-secondary btn-sm w-100 fw-semibold rounded-3"
                      onClick={handleClearOverAll}
                    >
                      Clear
                    </button>
                  </div>

                  <div className="col-md-4">
                    <button
                      className="btn btn-success btn-sm w-100 fw-semibold rounded-3"
                      onClick={handleUpdate}
                    >
                      Update
                    </button>
                  </div>

                  <div className="col-md-4">
                    <button
                      className="btn btn-danger btn-sm w-100 fw-semibold rounded-3"
                      onClick={handleCancel}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Service Modal - Same Design */}
      {/* <div
        className={`modal fade ${showAddService ? "show d-block" : ""}`}
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          display: showAddService ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editIndex !== null ? "Edit Service" : "Add New Service"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowAddService(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label fw-bold">Service Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="service_name"
                    value={selectedService.service_name}
                    onChange={handleServiceInputChange}
                    placeholder="Enter Service Name"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowAddService(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={addServiceToTable}
                disabled={isAddingService}
              >
                {editIndex !== null ? "Update Service" : "Add Service"}
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Add model popup */}
      <div
        className={`modal fade ${showAddModelModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Model</h5>

              <button
                type="button"
                className="btn-close"
                onClick={handleCloseAddModelModal}
              />
            </div>

            <form onSubmit={handleAddModel}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Brand</label>

                  <input
                    type="text"
                    className="form-control"
                    value={newModelData.brand}
                    readOnly
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Model Name</label>

                  <input
                    type="text"
                    className="form-control"
                    name="modelName"
                    value={newModelData.modelName}
                    onChange={handleNewModelInputChange}
                    required
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseAddModelModal}
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Update_JobSheet;
